/** 套餐展示元数据 — 配额以 Billing API 为准（§5.8 / billing.service.ts） */
export const planCatalog = {
  starter: {
    id: "starter" as const,
    name: "入门版",
    label: "入门版",
    priceHint: "免费试用 · 5 个项目 · 200 台设备",
    price: "¥0",
    projectQuota: 5,
    deviceQuota: 200,
  },
  growth: {
    id: "growth" as const,
    name: "成长版",
    label: "成长版",
    priceHint: "50 项目 · 1000 设备",
    price: "按项目计费",
    projectQuota: 50,
    deviceQuota: 1000,
  },
  scale: {
    id: "scale" as const,
    name: "规模版",
    label: "规模版",
    priceHint: "500 项目 · 10000 设备",
    price: "企业定价",
    projectQuota: 500,
    deviceQuota: 10000,
  },
};

export type PlanId = keyof typeof planCatalog;

const FALLBACK_PLAN = planCatalog.starter;

/** @deprecated 使用 useBilling()；仅作离线占位 */
export function getCurrentPlan() {
  return FALLBACK_PLAN;
}

export function planFromApi(planId: string | undefined) {
  if (planId && planId in planCatalog) {
    return planCatalog[planId as PlanId];
  }
  return FALLBACK_PLAN;
}
